const ComponentTitle = ({title, subTitle}) => {
    return(
        <div className="text-center space-y-4">
            <div className="space-y-2">
                <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                    {title}
                </h2>
                <div className="w-24 h-1 bg-slate-900 dark:bg-slate-400 rounded-full mx-auto transition-colors duration-300"></div>
            </div>
            <p className="text-slate-600 dark:text-slate-400 text-lg lg:text-xl font-light max-w-2xl mx-auto leading-relaxed transition-colors duration-300">
                {subTitle}
            </p>
        </div>
    )
}
export default ComponentTitle;